function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M22.1045 19.7602L20.3131 21.5516V18.75H18.7506V21.5516L16.9592 19.7602L15.8545 20.8648L19.5318 24.5422L23.2092 20.8648L22.1045 19.7602Z",
  fill: "#1ECD96"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18.75 7.8125V10.9375H20.3125V7.8125C20.3078 3.49976 16.8127 0.00473633 12.5 0V1.5625C15.9502 1.56636 18.7461 4.3623 18.75 7.8125Z",
  fill: "#1ECD96"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M6.25 17.1875V14.0625H4.6875V17.1875C4.69224 21.5002 8.18726 24.9953 12.5 25V23.4375C9.0498 23.4336 6.25386 20.6377 6.25 17.1875Z",
  fill: "#1ECD96"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M6.25 10.9375H4.6875V12.5H6.25V10.9375Z",
  fill: "#1ECD96"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M6.25 7.8125H4.6875V9.375H6.25V7.8125Z",
  fill: "#1ECD96"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M4.68809 6.24922H6.25059V3.44766L8.04199 5.23906L9.14668 4.13438L5.46934 0.457031L1.79199 4.13438L2.89668 5.23906L4.68809 3.44766V6.24922Z",
  fill: "#1ECD96"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M20.3125 12.5H18.75V14.0625H20.3125V12.5Z",
  fill: "#1ECD96"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M20.3125 15.625H18.75V17.1875H20.3125V15.625Z",
  fill: "#1ECD96"
});

var SvgSort = function SvgSort(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSort, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sort.7d440c01.svg";
export { ForwardRef as ReactComponent };